<template>
  <div class="kw_list_label" >
    <!--visitSource = 2  PC端 -->
    <div v-if="visitSource == 100">
      <template v-if="(pageSetInfo.operaButtonSet.length>0 && pageSetInfo.operaButtonSetIfHide) && checkDataInfo">
        <kw_btn_array :pageSetInfo="pageSetInfo" :dataInfo="checkDataInfo" :dataIndex="oneIndex" @dataButtonClick="dataButtonClick" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton"></kw_btn_array>
      </template>
      <div class="newITabs1" v-if="(pageSetInfo.listStyleSet && pageSetInfo.listStyleSet.imgPosition==1)" :current="oneCurrent">
        <div v-for="(item,index) in dataList" :key="'tab_'+index" >
          <div class="newITabsBox1" :style="'width:'+((100/dataList.length)-7)+'vw;'"  @click="oneChange({'name':item.LMF_ID,'index':index})">
            <div :style="item.BG_FILE?('background-image:url('+(GLOBAL.getFileServeUrl()+item.BG_FILE)+')'):''">
              <span>{{item[listFieldSet[0].fieldAliasName]}}</span>
            </div>
          </div>
        </div>
      </div>
      <kw_tabs v-else class="newITabs" v-model="oneCurrent" :scroll="true" @change="oneChange" i-class="newITabsBox" :tabsBoxStyleSet="pageSetInfo.listStyleSet.listPageTabsBoxCommonStyleSet?pageSetInfo.listStyleSet.listPageTabsBoxCommonStyleSet.styleSetCode:''" :tabsStyleSet="pageSetInfo.listStyleSet.listPageTabsCommonStyleSet?pageSetInfo.listStyleSet.listPageTabsCommonStyleSet.styleSetCode:''" >
          <div :class="pageSetInfo.listStyleSet.tabLine==0?'newITabsBoxTitleNew':'newITabsBoxTitle'">
            <kw_tab v-for="(item,index) in dataList" :key="'tab_'+index" :index="index" :name="item.LMF_ID" :title="item[listFieldSet[0].fieldAliasName]" :bgFile="(item.BG_FILE?GLOBAL.getFileServeUrl()+item.BG_FILE:'')" :type="pageSetInfo.listStyleSet.newTabLine?pageSetInfo.listStyleSet.newTabLine:''"  :fileType="(pageSetInfo.listStyleSet.isShowCardBgImg)" :tabBoxStyle="styleSetCodeZdy(pageSetInfo.listStyleSet.listPageTabBoxCommonStyleSet,item)" :tabDefaultStyle="styleSetCodeZdy(pageSetInfo.listStyleSet.listPageTabDefaultCommonStyleSet,item)" :tabCheckStyle="styleSetCodeZdy(pageSetInfo.listStyleSet.listPageTabCheckCommonStyleSet,item)" :definehover="pageSetInfo.listStyleSet.listPageTabHoverCommonStyleSet?pageSetInfo.listStyleSet.listPageTabHoverCommonStyleSet.defineHover:''" kwName="listPageTabBoxCommonStyleSet"></kw_tab>
          </div>
      </kw_tabs>

      <!-- 查看页面 -->
      <kw_look v-if="detailPageInfo.ifLoaded" :pageInfo="detailPageInfo" @goBack="goBack"  :isLimitButton="isLimitButton"></kw_look>
    </div>




    <!--visitSource = 3  移动端 -->
    <div v-else class="kw_list_label">
       <!-- 操作成功弹窗 -->
        <kw_dialog :isSuccess="isSuccess" @handelClose="handelClose"></kw_dialog>

      <template v-if="(pageSetInfo.operaButtonSet.length>0 && pageSetInfo.operaButtonSetIfHide) && checkDataInfo">
        <kw_btn_array :pageSetInfo="pageSetInfo" :dataInfo="checkDataInfo" :dataIndex="oneIndex" @dataButtonClick="dataButtonClick" :previewVisitSource="previewVisitSource" :isLimitButton="isLimitButton"></kw_btn_array>
      </template>

      <div class="newITabs1" v-if="(pageSetInfo.listStyleSet && pageSetInfo.listStyleSet.imgPosition==1)" :current="oneCurrent">
        <div v-for="(item,index) in dataList" :key="'tab_'+index" >
          <div class="newITabsBox1" :style="'width:'+((100/dataList.length)-7)+'vw;'"  @click="oneChange({'name':item.LMF_ID,'index':index})">
            <div :style="item.BG_FILE?('background-image:url('+(GLOBAL.getFileServeUrl()+item.BG_FILE)+')'):''">
              <span>{{item[listFieldSet[0].fieldAliasName]}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- pageSetInfo.listStyleSet.imgPosition为2时上部图 -->
      <!-- pageSetInfo.listStyleSet.imgPosition为无 -->
      <kw_tabs v-else class="newITabs" v-model="oneCurrent" :scroll="true" @change="oneChange" i-class="newITabsBox" :tabsBoxStyleSet="pageSetInfo.listStyleSet.listPageTabsBoxCommonStyleSet?pageSetInfo.listStyleSet.listPageTabsBoxCommonStyleSet.styleSetCode:''" :tabsStyleSet="pageSetInfo.listStyleSet.listPageTabsCommonStyleSet?pageSetInfo.listStyleSet.listPageTabsCommonStyleSet.styleSetCode:''"  kwName="listPageTabsBoxCommonStyleSet">
        <div :class="pageSetInfo.listStyleSet.tabLine==0?'newITabsBoxTitleNew':'newITabsBoxTitle'">
            <kw_tab v-for="(item,index) in dataList" :key="'tab_'+index" :index="index" :name="item.LMF_ID" :title="item[listFieldSet[0].fieldAliasName]" :bgFile="(item.BG_FILE?GLOBAL.getFileServeUrl()+item.BG_FILE:'')"  :type="pageSetInfo.listStyleSet.newTabLine?pageSetInfo.listStyleSet.newTabLine:''" :fileType="(pageSetInfo.listStyleSet.isShowCardBgImg)" :tabBoxStyle="styleSetCodeZdy(pageSetInfo.listStyleSet.listPageTabBoxCommonStyleSet,item)" :tabDefaultStyle="styleSetCodeZdy(pageSetInfo.listStyleSet.listPageTabDefaultCommonStyleSet,item)" :tabCheckStyle="styleSetCodeZdy(pageSetInfo.listStyleSet.listPageTabCheckCommonStyleSet,item)"  kwName="listPageTabDefaultCommonStyleSet"></kw_tab>
        </div>
      </kw_tabs>

      <!-- 查看页面 -->
      <kw_look @refreshevent="zdyRefreshPage" v-if="detailPageInfo.ifLoaded" :pageInfo="detailPageInfo" @goBack="goBack"  :isLimitButton="isLimitButton"></kw_look>
    </div>
    <el-dialog class="zdy_dialog" v-if="dialogInfo.ifLoad" :visible.sync="dialogInfo.ifLoad" width="100%" top="1vh" center append-to-body :close-on-click-modal="false" v-dialogDrag>
        <template slot="title"> 
            <div>
                {{(dialogInfo.pageInfo&&dialogInfo.pageInfo.menuName)?dialogInfo.pageInfo.menuName:'弹出层'}}
            </div>    
        </template>
        <kw_list v-if="dialogInfo.type==1" ref="kw_list_dialog" :initPageObj="dialogInfo.pageInfo" :isLimitButton="isLimitButton" :ifDialog="1"></kw_list>
        <kw_look v-else-if="dialogInfo.type==11" ref="kw_look_dialog" :pageInfo="dialogInfo.pageInfo" @goBack="dialogIframeZdyCancel" :isLimitButton="isLimitButton" :ifDialog="1"></kw_look>
        <iframe v-else-if="dialogInfo.type==999" ref="dialog999" :style="'width:100%;height:' + (windowHeight-70) + 'px;'" frameborder=0 name="showHere" scrolling=auto  :src="dialogInfo.url" ></iframe>
        <span slot="footer" v-if="dialogInfo.type==999">
            <el-button @click="dialogIframeZdyCancel">取 消</el-button>
            <el-button type="primary" @click="dialogIframeZdyConfirm">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

// kw_tabs 标签组组件
import kw_tabs from '@/components/kw/kw_tabs.vue';
// kw_tab 标签组件
import kw_tab from '@/components/kw/kw_tab.vue';
// i-tabs

// kw_dialog操作成功弹窗
import kw_dialog from "@/components/kw/kw_dialog.vue";

// 列表的按钮组件
import kw_btn_array from '@/components/look/kw_btn_array.vue';


export default {
  name: 'kw_list_label',
  props: {
    pageSetInfo:{
      type: Object,
      value: null
    },
    listFieldSet: {
      type: Array,
      value: null
    },
    //列表数据全部显示
    dataList: {
      type: Array,
      value: null
    },
    // 初始的默认选中值
    initCheckId: {
      type: String,
      value: null
    },
    //可以选中几个数据
    dataMaxNum: {
      type: Number,
      value: 1
    },
    // kw_list中的传递的mainId
    mainId:{
      value: 0
    },
    previewVisitSource:{
      type:Number,
      default:0
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    }
  },
  data() {
    var that = this;
    return {
      isSuccess: false,
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(that),
      oneCurrent: "",
      oneIndex:0,
      checkDataInfo:[],
      detailPageInfo:{},
      /**
       * 弹出层组件的信息
       */
      dialogInfo:{
          ifLoad:false
      },
    };
  },
  created() {
    this.initAttached();
  },
  mounted() {
    
  },
  watch:{
    dataList(){
     console.log("初始化时是否改变");
      this.initAttached();
    }
  },
  computed:{
  },
  components: {
    kw_tabs,
    kw_tab,
    kw_dialog,
    kw_btn_array,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
    kw_list:resolve => require(['@/components/list/kw_list.vue'], resolve)
  },
  methods: {
    styleSetCodeZdy(json,rowData) {
      if(json) {
        var styleSetCode = json.styleSetCode;
        if(json.zdyJs) {
          styleSetCode += eval(json.zdyJs);
        }
        return styleSetCode;
      } else {
        return "";
      }
    },
    handelClose() {
        this.isSuccess = false;
    },
    zdyRefreshPage:function(OperaType){
      if(OperaType==='9') {
        this.isSuccess = true;
      }
    },
    initAttached(){
      var that = this;
      var pageSetInfo = that.pageSetInfo;
      var styleSet = pageSetInfo.listStyleSet;
      var initCheckId = that.initCheckId;
      var oneCurrent = "";
      var oneIndex = 0;
      var checkDataInfo = [];
      var nowTableId = that.pageSetInfo.tableId;
      if (initCheckId && initCheckId > 0 && initCheckId != "" && that.dataList.length > 0) {
        var initCheckIdArr = initCheckId.split(",");
        for (var i = 0; i < initCheckIdArr.length; i++) {
          var nowCheckEle = that.dataList[i];
          oneCurrent += (oneCurrent != "" ? "," : "") + nowCheckEle['T_' + nowTableId + '_0'];
          oneIndex = i;
          checkDataInfo.push(nowCheckEle);
        }
      } else if(that.dataList[0] && that.dataList[0].NOW_CHECK_ID>0){
        that.dataList.forEach((dataOne,dataIndex) => {
          if(dataOne['T_' + nowTableId + '_0'] == dataOne.NOW_CHECK_ID) {
            oneCurrent += (oneCurrent != "" ? "," : "") + dataOne['T_' + nowTableId + '_0'];
            oneIndex = dataIndex;
            checkDataInfo.push(dataOne);
          }
        });
      } else {
        if (styleSet.clickType == 2) {
          if (that.dataList.length > 0) {
            oneCurrent = that.dataList[0].LMF_ID;
            checkDataInfo.push(that.dataList[0]);
          }
        }
      }

    //  console.log("oneCurrent=============================", oneCurrent, checkDataInfo);
      that.oneCurrent = oneCurrent+"";
      that.oneIndex = oneIndex;
      that.checkDataInfo = checkDataInfo[0];
      if (oneCurrent != 0) {
        that.showLookPage();
      }
    },
    oneChange(tab,event) {
//      console.log("tab============",tab);
      var that = this;
      var checkDataInfo = this.dataList[tab.index];
      // that.oneCurrent = tab.name;
      that.oneIndex = tab.index;
      that.checkDataInfo = checkDataInfo;
      that.showLookPage();
    },
    showLookPage(){
      var checkDataInfo = this.checkDataInfo;
      pageUtils.listDataClick(this, checkDataInfo);
    },

    /**
     * 返回前一页
     */
    goBack(){
      console.log("kw_list_label--------------goBack----------------");
      this.$emit("goBack");
    },
    
    /**
     * 调用父级组件选中的回调事件
     */
    eventTrigger: function (e) {
      var oneCurrent = this.oneCurrent; //通过这个传递数据
      var checkDataInfo = this.checkDataInfo;
      var myEventDetail = {
        val: oneCurrent,
        checkDataInfo: checkDataInfo
      } // detail对象，提供给事件监听函数
      this.$emit("callbackevent", myEventDetail);  //myevent自定义名称事件，父组件中使用
    },

    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (detail,dataInfo) {
      pageUtils.dataButtonClick(this,detail,dataInfo);
    },
    /**
     * 弹出层打开iframe时的确定按钮
     */
    dialogIframeZdyConfirm(){
      var that = this;
      that.$refs.dialog999.contentWindow.closeDialogFun=function(){
        that.dialogInfo.ifLoad = false;
      };
      that.$refs.dialog999.contentWindow.saveZdyPage();
    },
    /**
     * 弹出层打开iframe时的取消按钮
     */
    dialogIframeZdyCancel(ifRefresh){
      var that = this;
      this.dialogInfo.ifLoad = false;
      if(ifRefresh == 1) {
          this.refreshevent();
      }
    },
    refreshevent() {
        this.$emit("refreshevent");
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.newITabs1{display: flex;justify-content: space-between;border:1px solid #EFEFEF;padding: 10px;margin: 0 10px;border-bottom-left-radius: 5px;border-bottom-right-radius: 5px;background-color: #fff;border-top: none}
/* .newITabsBox{border-top:1px solid #EFEFEF} */
.newITabsBox1 div{background-repeat: no-repeat;width: 100%;height: 58px;background-size:100% 100%;}
.newITabsBox1 span{color: #fff;line-height: 58px;font-size: 16px;padding-left: 30px}

.newITabsBoxTitle{padding: 5px 0;overflow: auto;margin: 5px 10px}
.newITabsBoxTitleNew{padding: 5px}
</style>
